var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFavourite = function SvgFavourite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 21 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    d: "M10.813 18.226a2 2 0 0 1-.219-.11c-5.654-3.5-8.78-7.538-8.78-11.278 0-3.063 2.048-5.083 4.71-5.083 1.413 0 2.633.837 3.408 2.283l.884 1.65.88-1.653c.773-1.452 1.983-2.28 3.407-2.28 2.662 0 4.71 2.02 4.71 5.083 0 3.738-3.151 7.726-8.803 11.286a1.5 1.5 0 0 1-.197.102Z"
  })));
};
export default SvgFavourite;